// Merge the authoritative routes returned by the reopen endpoints back into the local project. Each
// returned route carries its FULL stop list with the reset statuses + recomputed ETAs, so overlaying it
// makes the dispatcher UI (routes list + route detail + stops tab) reflect the reopen immediately —
// without a manual page refresh. Field-level overlay by id preserves any other local stop/route fields
// and the existing stop ordering.
//
// Kept as its own tiny, dependency-free module so it stays unit-testable without importing the heavy
// store/actions graph (which pulls in MUI / DOM libs that break the jsdom test environment).
export const applyReopenedRoutes = (project, reopenedRoutes = []) => {
  if (!project) return project;
  const list = Array.isArray(reopenedRoutes) ? reopenedRoutes : [];

  const routeById = new Map(list.map(r => [r.id, r]));
  const stopById = new Map();
  list.forEach(r => (r.stops || []).forEach(s => stopById.set(s.id, s)));

  const updated = { ...project };

  if (updated.vrp && Array.isArray(updated.vrp.stops)) {
    updated.vrp = {
      ...updated.vrp,
      stops: updated.vrp.stops.map(s =>
        stopById.has(s.id) ? { ...s, ...stopById.get(s.id) } : s
      )
    };
  }

  if (updated.solution && Array.isArray(updated.solution.routes)) {
    updated.solution = {
      ...updated.solution,
      routes: updated.solution.routes.map(route => {
        const reopened = routeById.get(route.id);
        if (!reopened) return route;
        const reopenedStopById = new Map(
          (reopened.stops || []).map(s => [s.id, s])
        );
        return {
          ...route,
          status: reopened.status,
          stops: (route.stops || []).map(s =>
            reopenedStopById.has(s.id) ? { ...s, ...reopenedStopById.get(s.id) } : s
          )
        };
      })
    };
  }

  return updated;
};
